import {
  HIERARCHICAL_TREEMAP_LINE_HEIGHT,
  HIERARCHICAL_TREEMAP_PADDING,
} from './consts';

type HeaderNode = {
  /** `null` for the root, which is not drawn and reserves nothing. */
  parent: unknown;
  data: { subLabel: string | null };
};

/**
 * What a group reserves above its children: its name, a second line for the grouping rule's
 * label where there is one, and a gap below the pair.
 *
 * Reserved in the layout rather than only drawn, so a sublabel takes room from the group instead
 * of overlapping the first child. The gap matches the padding the group keeps at its other three
 * sides, which the top was missing — the first row of children sat against the underside of the
 * header stripe.
 */
export const toGroupHeaderHeight = (node: HeaderNode): number => {
  if (!node.parent) {
    return 0;
  }
  const lines = node.data.subLabel ? 2 : 1;
  return (
    lines * HIERARCHICAL_TREEMAP_LINE_HEIGHT + HIERARCHICAL_TREEMAP_PADDING
  );
};
